// extracted by mini-css-extract-plugin
export default {"container":"WSQuickFilters-module_container-UmfPW"};